import React from 'react';
import {
  NextButtonTooltipOptions,
  StepperSubmitAction,
  Step,
  StepperPageContextType,
} from '../components/Layout/StepperLayout/stepperTypes';

export const StepperPageContext = React.createContext<StepperPageContextType>({
  pageTitle: null,
  setPageTitle: (title: string) => null,
  steps: [],
  setSteps: (steps: Array<Step>) => null,
  onBack: () => null,
  onNext: () => null,
  activeStep: null,
  activeStepIndex: 0,
  onComplete: (isComplete?: boolean) => null,
  nextButtonTooltipOptions: null,
  // the next button displays a tooltip on hover when the match step
  // has some required fields that are not mapped. To display the tooltip
  // this function is called with the tooltip options (title, description)
  setNextButtonTooltipOptions: (options: NextButtonTooltipOptions | null) =>
    null,
  setAsyncNextHandler: (handler: () => void) => null,
  asyncNextHandler: null,
  loading: false,
  submitActions: [],
  setSubmitActions: (actions: Array<StepperSubmitAction>) => null,
  showStepper: true,
  setShowStepper: (show: boolean) => null,
});
